var checkIsTournamentGroup = function (tournament) {
    if (!tournament)
        return false;
    return 'grt' in tournament;
};
export { checkIsTournamentGroup };
